export default "__VITE_ASSET__pm5h698$__"